import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_CREATE_SCHEDULE_BEGIN,
  SCHEDULE_CREATE_SCHEDULE_SUCCESS,
  SCHEDULE_CREATE_SCHEDULE_FAILURE,
  SCHEDULE_CREATE_SCHEDULE_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_CREATE_SCHEDULE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/`;
      const doRequest = axios.post(url, args, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: SCHEDULE_CREATE_SCHEDULE_SUCCESS,
              data: res.data,
            });
            toast.success('Task Created Successfully !');
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: SCHEDULE_CREATE_SCHEDULE_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to creat collection');
            toast.error(`Failed: ${errMsg}`, {});
            resolve('Failed');
          }
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          if (err.response.status && err.response.status === 400) {
            dispatch({
              type: SCHEDULE_CREATE_SCHEDULE_FAILURE,
              data: { error: errMsg },
            });
            resolve(errMsg);
          }
          dispatch({
            type: SCHEDULE_CREATE_SCHEDULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateScheduleError() {
  return {
    type: SCHEDULE_CREATE_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_CREATE_SCHEDULE_BEGIN:
      return {
        ...state,
        createSchedulePending: true,
        createScheduleError: null,
      };

    case SCHEDULE_CREATE_SCHEDULE_SUCCESS:
      return {
        ...state,
        createSchedulePending: false,
        createScheduleError: null,
      };

    case SCHEDULE_CREATE_SCHEDULE_FAILURE:
      return {
        ...state,
        createSchedulePending: false,
        createScheduleError: action.data.error,
      };

    case SCHEDULE_CREATE_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        createScheduleError: null,
      };

    default:
      return state;
  }
}
